import React from 'react'
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import MenuIcon from '@material-ui/icons/Menu';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { Grid,InputBase,TextField } from '@material-ui/core';
import { fade, makeStyles } from '@material-ui/core/styles';

import HeaderListItem from './HeaderListItem';
import SearchBox from './SearchBox';

class Header extends React.Component{
    constructor(props){
        super(props)
        this.state={
            open:false,
            update:false,
            showSearchBox:false
        }
        window.addEventListener('resize',this.handleSrceenResize)
    }
    //this is to handle srceen resize event
    handleSrceenResize=()=>{
        this.setState({
            update:(!this.state.update),
            open:false
        })
    }

    renderDrawer=()=>{
        // let searchBox=null
        // if(window.screen.width<500){
        //     searchBox=<div style={{paddingRight:10,}}>
        //                 <SearchBox/>
        //               </div>
        // }
        return <Drawer open={this.state.open} onClose={this.toggleDrawer} >
        <div style={{    width: Math.max([window.screen.width/2,400])}}>
                    <List>
                        <ListItem button >
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-around',
                            width: '180px',
                            alignItems: 'center'
                        }}>
                            <div>
                                <img src='/logo.png' style={{
                                        width: '50px',
                                        height: '50px'
                                }}/>
                            </div>
                            <div>
                                <Typography variant='h4'>
                                    Actumjs
                                </Typography>
                            </div>
                        </div>
                        </ListItem>
                        {[{text:'Home',link:'/'},{text:'Getting Started',link:'/get-started'}, {text:'API',link:'/api'},{text:'Examples',link:'/examples'}].map((item, index) => (
                        <ListItem button key={index} component='a' href={item.link}>
                            <ListItemText primary={item.text} />
                        </ListItem>
                        ))}
                        {/* <ListItem>
                         {searchBox}
                        </ListItem> */}
                    </List>
                </div>
               </Drawer>
    }
    //this is to render menu
    renderMenu=()=>{
        if(window.screen.width<=768){
            let searchBox=null
            if(window.screen.width>500){
                searchBox=<div style={{paddingRight:10}}>
                            <SearchBox/>
                          </div>
            }else{
                    if(!this.state.showSearchBox){
                        searchBox=<IconButton edge="start" color="inherit" aria-label="menu" onClick={()=>{this.setState({showSearchBox:true})}}>
                            <SearchIcon/>
                        </IconButton>

                    }
            }

            return <Grid container justify='flex-end' >
                        <Grid>
                            {searchBox}
                           
                        </Grid>
                        <Grid >
                                <IconButton edge="start" color="inherit" aria-label="menu" onClick={this.toggleDrawer}>
                                    <MenuIcon />
                                </IconButton>
                        </Grid>
                    </Grid> 
        }else{
            return  <Grid container justify='flex-end' spacing={8}>
                        <Grid >
                                    <HeaderListItem text="Home" url="/" />
                        </Grid>
                        <Grid >
                                    <HeaderListItem text="Get Started" url="/get-started" />
                        </Grid>
                        <Grid >
                                    <HeaderListItem text="API Documentation" url="/api" />
                        </Grid>
                        <Grid >
                                    <HeaderListItem text="Examples" url="/examples"/>
                        </Grid>
                        <Grid>
                                <div style={{paddingRight:10,marginTop: -11}}>
                                    <SearchBox/>
                                </div>
                        </Grid>
                    </Grid>
        }
    }
    toggleDrawer=()=>{
        this.setState({open:(!this.state.open)})
    }
    render(){
        let drawer=this.renderDrawer();
        let menu=this.renderMenu();
        let logoText=<div><Typography variant='h4'>Actumjs</Typography></div>
        if(window.screen.width<500){
            if(this.state.showSearchBox){
                logoText=<div style={{marginRight: "-69px",}}><SearchBox width="200px" onBlur={()=>{this.setState({showSearchBox:false})}}/></div>
            }
        }
        return <>
            <AppBar position="fixed" style={{background:'white',color:'black',paddingTop:'10px'}}>
                    <Toolbar >

                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-around',
                            width: '180px',
                            alignItems: 'center'
                        }}>
                            <div>
                                <img src='/logo.png' style={{
                                        width: '50px',
                                        height: '50px'
                                    }}/>
                            </div>
                            {logoText}
                        </div>
                        {menu}

                    </Toolbar>
        </AppBar>
        {drawer}
        </>
    }
}
export default Header;